<template>
  <div class="d-flex pt-2">
    <!-- filtersChips -->
    <span v-for="chip in filtersChips" :key="chip.field">
      <v-chip
        v-if="value[chip.field]"
        color="primary"
        outlined
        close
        small
        @click:close="handleCleanFilter(chip.field)"
      >
        {{ chip.description }}
      </v-chip>
    </span>

    <!-- Ordenar por -->
    <HomeSearchMenuOrder :order="model.order" @change="handleChangeOrder" />

    <!-- Filtros -->
    <HomeSearchMenuFilter
      :value="model"
      @apply-filters="$emit('apply-filters', $event)"
      @update-filters="$emit('update-filters', $event)"
      @has-active-filters="$emit('has-active-filters')"
    />
  </div>
</template>

<script>
import { dateFormat } from '@/utils/date.js';
import { sortOrder } from '@/utils/mappers.js';
import makeDeepCopy from '@/utils/makeDeepCopy.js';
import { debounce, truncate } from 'lodash';
import HomeSearchMenuOrder from './HomeSearchMenuOrder';
import HomeSearchMenuFilter from './HomeSearchMenuFilter';

export default {
  name: 'HomeSearchMenu',
  components: {
    HomeSearchMenuOrder,
    HomeSearchMenuFilter,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        order: sortOrder.DESC,
        fromDate: undefined,
        toDate: undefined,
        author: undefined,
      }),
    },
  },

  data() {
    return {
      sortOrder,
      menuFromDate: null,
      menuToDate: null,
      model: {
        order: sortOrder.DESC,
        fromDate: undefined,
        toDate: undefined,
        author: undefined,
      },
    };
  },

  watch: {
    value: {
      immediate: true,
      deep: true,
      handler() {
        this.sync();
      },
    },
  },

  computed: {
    filtersChips() {
      return [
        {
          field: 'author',
          description: `Autor: ${truncate(this.value.author, { length: 15 })}`,
        },
        {
          field: 'fromDate',
          description: `Inicial: ${
            this.value.fromDate ? dateFormat(this.value.fromDate) : undefined
          }`,
        },
        {
          field: 'toDate',
          description: `Final: ${
            this.value.toDate ? dateFormat(this.value.toDate) : undefined
          }`,
        },
      ];
    },
    hasActiveFilters() {
      return (
        !!this.model.fromDate || !!this.model.toDate || !!this.model.author
      );
    },
  },

  methods: {
    truncate,
    sync() {
      this.model = makeDeepCopy(this.value);
    },
    handleChangeOrder(order) {
      this.model.order = order;
      this.handleFilter();
    },
    handleCleanFilter(field) {
      this.model[field] = undefined;
      this.handleFilter();
    },
    handleFilter() {
      this.$emit('update-filters', makeDeepCopy(this.model));
      this.applyFilters();
    },
    applyFilters: debounce(function() {
      this.$emit('apply-filters');
      this.$emit('has-active-filters', this.hasActiveFilters);
    }, parseInt(process.env.VUE_APP_FILTER_DELAY) || 2000),
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/theme-v2.scss';
@import '@/assets/scss/buttons.scss';
@import '@/assets/scss/inputs.scss';

.v-chip {
  margin: 0 !important;
  margin-right: 5px !important;
}
</style>
